import React from 'react';
import PropTypes from 'prop-types';
import {
  AppBar,
  Box,
  Checkbox,
  FormControlLabel,
  FormGroup,
  Stack,
  Toolbar,
  Tooltip,
  Typography,
} from '@mui/material';

function addSpacesToCamelCase(str) {
  return str.replace(/([A-Z])/g, ' $1').replace(/^./, function (str) {
    return str.toUpperCase();
  });
}

function AssignClaims({ claims, claimsCheckedState, setClaimsCheckedState }) {
  return (
    <>
      <AppBar position="static" color="secondary">
        <Toolbar variant="dense">
          <Typography variant="h6" color="inherit" component="div">
            Claims
          </Typography>
        </Toolbar>
      </AppBar>
      <Box sx={{ paddingTop: '5px' }}>
        <Stack direction="row" spacing={2}>
          <FormGroup>
            {claims
              .sort((a, b) => (a.name > b.name ? 1 : -1))
              .filter((c, idx) => idx <= claims.length / 2)
              .map((c, idx) => (
                <Tooltip
                  title={c.description}
                  enterDelay={500}
                  arrow
                  slotProps={{ tooltip: { sx: { fontSize: '0.9em' } } }}
                  key={idx}
                >
                  <FormControlLabel
                    control={
                      <Checkbox
                        size="small"
                        checked={claimsCheckedState[c.name] || false}
                        name={c.name}
                        onChange={(e) => {
                          const claimsCheckedStateCopy = { ...claimsCheckedState };
                          claimsCheckedStateCopy[e.target.name] = e.target.checked;
                          setClaimsCheckedState(claimsCheckedStateCopy);
                        }}
                      />
                    }
                    label={addSpacesToCamelCase(c.name)}
                  />
                </Tooltip>
              ))}
          </FormGroup>
          <FormGroup>
            {claims
              .sort((a, b) => (a.name > b.name ? 1 : -1))
              .filter((c, idx) => idx > claims.length / 2)
              .map((c, idx) => (
                <Tooltip
                  title={c.description}
                  enterDelay={500}
                  arrow
                  slotProps={{ tooltip: { sx: { fontSize: '0.9em' } } }}
                  key={idx}
                >
                  <FormControlLabel
                    control={
                      <Checkbox
                        size="small"
                        checked={claimsCheckedState[c.name] || false}
                        name={c.name}
                        onChange={(e) => {
                          const claimsCheckedStateCopy = { ...claimsCheckedState };
                          claimsCheckedStateCopy[e.target.name] = e.target.checked;
                          setClaimsCheckedState(claimsCheckedStateCopy);
                        }}
                      />
                    }
                    label={addSpacesToCamelCase(c.name)}
                  />
                </Tooltip>
              ))}
          </FormGroup>
        </Stack>
      </Box>
    </>
  );
}

AssignClaims.propTypes = {
  claims: PropTypes.array.isRequired,
  claimsCheckedState: PropTypes.object.isRequired,
  setClaimsCheckedState: PropTypes.func.isRequired,
};

export default AssignClaims;
